import { Dispatch } from 'redux';

import * as Actions from '../actions/quickModeContens';
import AbstractScenario from './AbstractScenario';

export default class QuickModeFactory {
	/**
	 * manageOrg取得
	 * @param dispatch
	 * @param token
	 */
	public static createFetchManageOrg(dispatch: Dispatch, token: string) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<{}> {
			protected process() {
				const param = {
					accessType: '10',
				};
				return this.read('per_quickMode_manageOrg', param).then(
					data => {
						const manageOrgList = data;
						dispatch(Actions.setManageOrg({ manageOrgList }));
					}
				);
			}
		}(dispatch, token);
		return scenario;
	}
}



// WEBPACK FOOTER //
// ./src/scenario/QuickModeFactory.ts